/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeBotLicensesResponse,
  ApiEnvelopeMyBotLicensesResponse,
  ApiEnvelopeUserBotLicensesResponse
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type botLicenseMeResponse200 = {
  data: ApiEnvelopeMyBotLicensesResponse
  status: 200
}

export type botLicenseMeResponse401 = {
  data: ApiEnvelopeMyBotLicensesResponse
  status: 401
}

export type botLicenseMeResponseSuccess = (botLicenseMeResponse200) & {
  headers: Headers;
};
export type botLicenseMeResponseError = (botLicenseMeResponse401) & {
  headers: Headers;
};

export type botLicenseMeResponse = (botLicenseMeResponseSuccess | botLicenseMeResponseError)

export const getBotLicenseMeUrl = () => {




  return `/api/botlicenses/me`
}

export const useBotLicenseMeHook = (): ( options?: RequestInit) => Promise<botLicenseMeResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getBotLicenseMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botLicenseForBotResponse200 = {
  data: ApiEnvelopeBotLicensesResponse
  status: 200
}

export type botLicenseForBotResponse401 = {
  data: ApiEnvelopeBotLicensesResponse
  status: 401
}

export type botLicenseForBotResponse403 = {
  data: ApiEnvelopeBotLicensesResponse
  status: 403
}

export type botLicenseForBotResponse404 = {
  data: ApiEnvelopeBotLicensesResponse
  status: 404
}

export type botLicenseForBotResponseSuccess = (botLicenseForBotResponse200) & {
  headers: Headers;
};
export type botLicenseForBotResponseError = (botLicenseForBotResponse401 | botLicenseForBotResponse403 | botLicenseForBotResponse404) & {
  headers: Headers;
};

export type botLicenseForBotResponse = (botLicenseForBotResponseSuccess | botLicenseForBotResponseError)

export const getBotLicenseForBotUrl = (botId: string,) => {




  return `/api/botlicenses/bots/${botId}`
}

export const useBotLicenseForBotHook = (): (botId: string, options?: RequestInit) => Promise<botLicenseForBotResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getBotLicenseForBotUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botLicenseAttachResponse200 = {
  data: ApiEnvelopeBotLicensesResponse
  status: 200
}

export type botLicenseAttachResponse400 = {
  data: ApiEnvelopeBotLicensesResponse
  status: 400
}

export type botLicenseAttachResponse401 = {
  data: ApiEnvelopeBotLicensesResponse
  status: 401
}

export type botLicenseAttachResponse403 = {
  data: ApiEnvelopeBotLicensesResponse
  status: 403
}

export type botLicenseAttachResponse404 = {
  data: ApiEnvelopeBotLicensesResponse
  status: 404
}

export type botLicenseAttachResponseSuccess = (botLicenseAttachResponse200) & {
  headers: Headers;
};
export type botLicenseAttachResponseError = (botLicenseAttachResponse400 | botLicenseAttachResponse401 | botLicenseAttachResponse403 | botLicenseAttachResponse404) & {
  headers: Headers;
};

export type botLicenseAttachResponse = (botLicenseAttachResponseSuccess | botLicenseAttachResponseError)

export const getBotLicenseAttachUrl = (botId: string,
    licenseType: string,) => {




  return `/api/botlicenses/bots/${botId}/${licenseType}`
}

export const useBotLicenseAttachHook = (): (botId: string,
    licenseType: string, options?: RequestInit) => Promise<botLicenseAttachResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    licenseType: string, options?: RequestInit) => {

        return customFetcher(getBotLicenseAttachUrl(botId,licenseType),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type botLicenseDetachResponse200 = {
  data: ApiEnvelopeBotLicensesResponse
  status: 200
}

export type botLicenseDetachResponse401 = {
  data: ApiEnvelopeBotLicensesResponse
  status: 401
}

export type botLicenseDetachResponse403 = {
  data: ApiEnvelopeBotLicensesResponse
  status: 403
}

export type botLicenseDetachResponse404 = {
  data: ApiEnvelopeBotLicensesResponse
  status: 404
}

export type botLicenseDetachResponseSuccess = (botLicenseDetachResponse200) & {
  headers: Headers;
};
export type botLicenseDetachResponseError = (botLicenseDetachResponse401 | botLicenseDetachResponse403 | botLicenseDetachResponse404) & {
  headers: Headers;
};

export type botLicenseDetachResponse = (botLicenseDetachResponseSuccess | botLicenseDetachResponseError)

export const getBotLicenseDetachUrl = (botId: string,
    licenseType: string,) => {




  return `/api/botlicenses/bots/${botId}/${licenseType}`
}

export const useBotLicenseDetachHook = (): (botId: string,
    licenseType: string, options?: RequestInit) => Promise<botLicenseDetachResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    licenseType: string, options?: RequestInit) => {

        return customFetcher(getBotLicenseDetachUrl(botId,licenseType),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type botLicenseAdminUserSeatsResponse200 = {
  data: ApiEnvelopeUserBotLicensesResponse
  status: 200
}

export type botLicenseAdminUserSeatsResponse401 = {
  data: ApiEnvelopeUserBotLicensesResponse
  status: 401
}

export type botLicenseAdminUserSeatsResponse403 = {
  data: ApiEnvelopeUserBotLicensesResponse
  status: 403
}

export type botLicenseAdminUserSeatsResponseSuccess = (botLicenseAdminUserSeatsResponse200) & {
  headers: Headers;
};
export type botLicenseAdminUserSeatsResponseError = (botLicenseAdminUserSeatsResponse401 | botLicenseAdminUserSeatsResponse403) & {
  headers: Headers;
};

export type botLicenseAdminUserSeatsResponse = (botLicenseAdminUserSeatsResponseSuccess | botLicenseAdminUserSeatsResponseError)

export const getBotLicenseAdminUserSeatsUrl = (userId: string,) => {




  return `/api/botlicenses/admin/user/${userId}`
}

export const useBotLicenseAdminUserSeatsHook = (): (userId: string, options?: RequestInit) => Promise<botLicenseAdminUserSeatsResponse> => {

      const customFetcher = useSfetchMutator();
      return (userId: string, options?: RequestInit) => {

        return customFetcher(getBotLicenseAdminUserSeatsUrl(userId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botLicenseAdminRevokeResponse200 = {
  data: ApiEnvelopeUserBotLicensesResponse
  status: 200
}

export type botLicenseAdminRevokeResponse401 = {
  data: ApiEnvelopeUserBotLicensesResponse
  status: 401
}

export type botLicenseAdminRevokeResponse403 = {
  data: ApiEnvelopeUserBotLicensesResponse
  status: 403
}

export type botLicenseAdminRevokeResponse404 = {
  data: ApiEnvelopeUserBotLicensesResponse
  status: 404
}

export type botLicenseAdminRevokeResponseSuccess = (botLicenseAdminRevokeResponse200) & {
  headers: Headers;
};
export type botLicenseAdminRevokeResponseError = (botLicenseAdminRevokeResponse401 | botLicenseAdminRevokeResponse403 | botLicenseAdminRevokeResponse404) & {
  headers: Headers;
};

export type botLicenseAdminRevokeResponse = (botLicenseAdminRevokeResponseSuccess | botLicenseAdminRevokeResponseError)

export const getBotLicenseAdminRevokeUrl = (assignmentId: string,) => {




  return `/api/botlicenses/admin/assignments/${assignmentId}`
}

export const useBotLicenseAdminRevokeHook = (): (assignmentId: string, options?: RequestInit) => Promise<botLicenseAdminRevokeResponse> => {

      const customFetcher = useSfetchMutator();
      return (assignmentId: string, options?: RequestInit) => {

        return customFetcher(getBotLicenseAdminRevokeUrl(assignmentId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type botLicenseAdminClearCooldownResponse200 = {
  data: ApiEnvelopeUserBotLicensesResponse
  status: 200
}

export type botLicenseAdminClearCooldownResponse401 = {
  data: ApiEnvelopeUserBotLicensesResponse
  status: 401
}

export type botLicenseAdminClearCooldownResponse403 = {
  data: ApiEnvelopeUserBotLicensesResponse
  status: 403
}

export type botLicenseAdminClearCooldownResponse404 = {
  data: ApiEnvelopeUserBotLicensesResponse
  status: 404
}

export type botLicenseAdminClearCooldownResponseSuccess = (botLicenseAdminClearCooldownResponse200) & {
  headers: Headers;
};
export type botLicenseAdminClearCooldownResponseError = (botLicenseAdminClearCooldownResponse401 | botLicenseAdminClearCooldownResponse403 | botLicenseAdminClearCooldownResponse404) & {
  headers: Headers;
};

export type botLicenseAdminClearCooldownResponse = (botLicenseAdminClearCooldownResponseSuccess | botLicenseAdminClearCooldownResponseError)

export const getBotLicenseAdminClearCooldownUrl = (assignmentId: string,) => {




  return `/api/botlicenses/admin/assignments/${assignmentId}/clear-cooldown`
}

export const useBotLicenseAdminClearCooldownHook = (): (assignmentId: string, options?: RequestInit) => Promise<botLicenseAdminClearCooldownResponse> => {

      const customFetcher = useSfetchMutator();
      return (assignmentId: string, options?: RequestInit) => {

        return customFetcher(getBotLicenseAdminClearCooldownUrl(assignmentId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


